import { render, staticRenderFns } from "./CouncilList.vue?vue&type=template&id=e702a25c&scoped=true"
import script from "./CouncilList.vue?vue&type=script&lang=js"
export * from "./CouncilList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e702a25c",
  null
  
)

export default component.exports